export default {
  ja: {
    common: {
      suzuka: '久松 涼夏',
      wolke: 'Gallery Wolke',
    },
    home: {
      videoinfo: '会場の様子などを写しています',
      worksinfo: '展示作品をご覧いただけます',
      aboutinfo: '展示の詳細や、久松涼夏について',
      videobtn: 'ビデオを見る',
      worksbtn: '作品を見る',
      aboutbtn: '詳細を見る',
      contact: '連絡先',
    },
    info: {
      history: {
        1: { year: '1990', item: '東京生まれ' },
        2: { year: '2013', item: '女子美術大学入学' },
        3: { year: '2015', item: 'ウィーン応用美術大学 留学' },
        4: { year: '2016', item: '上海交通大学サマープログラム　デザインコンペ３位 (上海、中国)' },
        5: { year: '', item: '田原桂一 in 女子美 光合成プロジェクト (日本)' },
        6: { year: '2017', item: 'ブレラ国立美術学院 女子美術大学 交流作品展 (ミラノ・旧聖カルポーフォロ教会、イタリア)' },
        7: { year: '', item: '女子美術大学卒業' },
        8: { year: '', item: 'ウィーン応用美術大学 ペインティングクラス(Prof. ヘニング・ボール) 入学' },
        9: { year: '', item: '堀田育英財団 奨学生 2017−2019' },
        10: { year: '', item: 'グループ展 Under the sky (ウィーン、オーストリア)' },
        11: { year: '2018', item: 'グループ展 RAND (ウィーン、オーストリア)' },
        12: { year: '', item: 'グループパフォーマンス The Art of Sleeping (ウィーン、オーストリア)' },
        13: { year: '', item: '個展 水槽の中の蝶 (東京 Gallery Wolke, 日本)' },
        14: { year: '2019', item: 'グループ展 Aus GUTEM HAUSE (ウィーン Educult in MQ Wien、オーストリア)' },
        15: { year: '', item: 'グループ展 Cute but Creepy (ウィーン wasserwasser、オーストリア)' },
        16: { year: '2020', item: 'グループパフォーマンス Art and Sound (ウィーン oskarkokoschka-2、オーストリア)' },
        17: { year: '', item: 'グループ展 Cute but Creepy vol.2 (ウィーン dieschone、オーストリア)' },
        // 18: { year: '', item: '個展 between us (東京 Gallery Wolke、日本)' },
      },
      exhibition: {
        period: {
          title: '会期',
          sentense1: '2020年7月12日（日）〜7月19日（日） ※水曜日定休日',
          sentense2: '10:00−19:00',
        },
        venue: {
          title: '会場',
          sentense1: 'Gallery Wolke (東京 大崎)',
        },
        info: {
          1: 'between dream and reality',
          2: 'between love and hate',
          3: 'between here and there',
          4: 'between red and purple',
          5: 'between you and me',
        }
      }
    },
    video: {
      venue: '展示場の様子',
      production: '制作現場'
    },
  }
}
